import { render, staticRenderFns } from "./DataGridImageUpload.vue?vue&type=template&id=96e05340"
import script from "./DataGridImageUpload.vue?vue&type=script&lang=js"
export * from "./DataGridImageUpload.vue?vue&type=script&lang=js"
import style0 from "./DataGridImageUpload.vue?vue&type=style&index=0&id=96e05340&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports